var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-start": ""
    }
  }, [!!_vm.desc ? _c('span', [_vm._v(" " + _vm._s(_vm.desc) + " ")]) : _vm._e(), !!_vm.coda ? _c('span', [_vm._v(" " + _vm._s(_vm.coda) + " ")]) : _vm._e(), (_vm.isUserEmployee || _vm.isUserEmployer) && !_vm.isOnline ? [_c('expo-employer-map', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "px-8 mt-10",
          attrs: {
            "small": "",
            "height": "28",
            "color": "kakao"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "ml-n2",
          attrs: {
            "size": "20",
            "color": "kakao-marker"
          }
        }, [_vm._v("mdi-map-marker")]), _c('span', [_vm._v(" 카카오맵 확인 ")])], 1)];
      }
    }], null, false, 662236830)
  }, 'expo-employer-map', {
    employer: _vm.item.employer
  }, false))] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }